var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('portal',{attrs:{"to":"toolbar-title"}},[_vm._v(" Αναγγελία Βλάβης")]),_c('portal',{attrs:{"to":"toolbar-actions"}}),_c('div',{staticClass:"new-callout-container"},[_c('new-callout')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }